
import { Log } from '@probe.gl/log';
export const log = new Log({
  id: 'loaders.gl'
});
//# sourceMappingURL=log.js.map